import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { WaterMeasure } from 'src/app/domain/EAU/water-measure';

@Component({
    selector: 'app-water-measure-box',
    templateUrl: './water-measure-box.html',
    styleUrls: ['./water-measure-box.scss']
})
export class WaterDialogBoxDialog implements OnInit {

    public newMesure: WaterMeasure = new WaterMeasure();
    public VUnder15; // Specific field for littre river when depth under 15cm
    public VMAX = 2; // m/s
    public PMAX = 150; // cm
    public DMAX = 20; // m

    ValidDistanceMax = new UntypedFormControl(0, [Validators.max(this.DMAX)]);
    ValidProfMax = new UntypedFormControl(0, [Validators.max(this.PMAX)]);
    ValidVUnder15Max = new UntypedFormControl(0, [Validators.max(this.VMAX)]);
    ValidV02PMax = new UntypedFormControl(0, [Validators.max(this.VMAX)]);
    ValidV04PMax = new UntypedFormControl(0, [Validators.max(this.VMAX)]);
    ValidV08PMax = new UntypedFormControl(0, [Validators.max(this.VMAX)]);

    get Under15() {
        return this.newMesure.Profondeur <= 15;
    }

    constructor(
        public dialogRef: MatDialogRef<WaterDialogBoxDialog>,
        @Inject(MAT_DIALOG_DATA) public data) {

        this.newMesure = data;
    }

    ngOnInit() {
        this.ValidDistanceMax.markAsTouched();
        this.ValidProfMax.markAsTouched();
        this.ValidV02PMax.markAsTouched();
        this.ValidV04PMax.markAsTouched();
        this.ValidV08PMax.markAsTouched();
        this.ValidVUnder15Max.markAsTouched();
    }

    CanAddNewMeasure() {
        if (!this.newMesure.Distance || !this.newMesure.Profondeur) {
            return;
        }

        if (this.Under15) {
            return this.VUnder15;
        } else {
            if (this.newMesure.V02P && this.newMesure.V04P && this.newMesure.V08P)
                return true;
        }

        return false;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        if (this.Under15) {
            this.newMesure.V02P = this.VUnder15;
            this.newMesure.V04P = this.VUnder15;
            this.newMesure.V08P = this.VUnder15;
        }
        this.dialogRef.close(this.newMesure);
    }
}
